"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeout = void 0;
exports.timeout = (promise, { timeout, errorMessage }) => async (props) => {
    return new Promise(function (resolve, reject) {
        const timer = setTimeout(() => {
            reject(errorMessage || "Timed out");
        }, timeout);
        promise(props)
            .then(function (res) {
            clearTimeout(timer);
            resolve(res);
        })
            .catch(function (err) {
            clearTimeout(timer);
            reject(err);
        });
    });
};
exports.default = exports.timeout;
